import { plus,  close_beta } from "assets";
import { useState } from "react";
import styled from "styled-components";
// import up_arrow_pink from "assets/icons/up_arrow_pink.svg";
// import down_arrow from "assets/icons/down_arrow.svg";

const Wrapper = styled.div`
  & + & {
    margin-top: 2.4rem;
    @media (max-width: 768px) {
      margin-top: 1.2rem;
    }
  }

  position: relative;
  /* padding: ${(props) => (props.withPadding ? "0 " : "0 2.4rem")}; */
  padding: 2.4rem 0;
  /* padding-left: 0; */
  transition: all 0.2s ease-out;
  border-radius: 0.8rem;
  &:hover {
    /* background-color: var(--off_white); */
  }

  border-bottom: ${(props) => props?.withBorder && "1px solid var(--grey_10)"}; 
  border-bottom-right-radius: ${(props) => props?.withBorder && "0"};
  border-bottom-left-radius: ${(props) => props?.withBorder && "0"};

  h6 {
    color: var(--grey_1);
    cursor: pointer;
    font-weight: 450;
    font-size: 2rem;
    line-height: 2.6rem;
    /* padding: 2.4rem; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      padding: 0;
      img {
        /* height: 100%; */
      width: 1.4rem;
        /* width: 100%; */
      }
    }

    @media (max-width: 768px) {
      font-size: 1.4rem;
      line-height: 20px;
      padding: 1.2rem 0;
    }
  }

  p {
    height: 0;
    overflow: hidden;
    opacity: 0;
    color: var(--grey_1);
    transition: all 250ms;
    /* line-height: 0; */

    /* @media (max-width: 768px) {
      padding: 1.2rem;
      font-size: 14px;
      line-height: 18px;
    } */
  }

  &.open {
    /* background-color: var(--off_white); */
    /* padding: 2.4rem; */

    p {
      /* margin-top: 1.6rem; */
      /* padding: 0 2.4rem 2.4rem; */
      padding-top: 2.4rem;
      height: auto;
      overflow: hidden;
      opacity: 1;
      margin-bottom: 0;

      @media (max-width: 768px) {
        padding: 1.2rem 0;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 1.2rem 0;

    .acc-title {
      justify-content: space-between;
    }
  }
`;

const Accordion = ({ question, answer, className, withPadding,withBorder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Wrapper
      withPadding={ withPadding }
      withBorder={withBorder}
      className={`${className || ""} ${isOpen ? "open" : ""}`}
      onClick={handleClick}
    >
      <h6 className="subtitle-2 acc-title flexRow">
        <span>{question}</span>
        <button> <img src={isOpen ? close_beta : plus} alt={isOpen ? "cancel": "plus"} /> </button>
      </h6>
      <p className="subtitle-3">{answer}</p>
    </Wrapper>
  );
};

export default Accordion;
